import React, { useState } from 'react'
 
 
import WarehouseTransferList from './WarehouseTransferList';
import WarehouseTransferForm from './WarehouseTransferForm';

const WarehouseTransfer= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");


  return (
    <>
      {fromIsShown ? (
          <WarehouseTransferForm addForm={setFromIsShown} update={upData} sId={serviceId} />
        ) : (
          <WarehouseTransferList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}  
    </>
  )
}

export default WarehouseTransfer